import React, {Component, useState} from 'react';

import {
    Button,
    ComboBox, Dropdown,
    Accordion, AccordionItem, TextInput
} from "carbon-components-react";
import BasicDateTimePicker from "../DatePicker";
import "./index.scss";
import {Filter20} from "@carbon/icons-react";

export default class extends Component {

    state = {
        form: {
            name: "",
            origin: ""
        }
    };

    constructor(props) {
        super(props);
        //this.handleChange = this.handleChange.bind(this);

    }

    componentDidMount() {
        let {form} = this.props;
        this.setState({
            form: {
                name: typeof form.name != "undefined" ? form.name : "",
                origin: typeof form.origin != "undefined" ? form.origin : ""
            }
        })
    }

    handleSubmit = async (e) => {
        this.props.onSubmitForm(this.state.form);
    }

    handleChange = e => {
        e.preventDefault();
        const {name, value} = e.target;
        this.setState(prevState => ({
            form: {...prevState.form, [name]: value}
        }));
    };

    onChangeDate(dateFrom) {
        this.setState(prevState => ({
            form: {...prevState.form, ["dateFrom"]: dateFrom}
        }));
    };

    handledateTo(dateTo) {
        this.setState(prevState => ({
            form: {...prevState.form, ["dateTo"]: dateTo}
        }));
    };


    render() {
        let {data} = this.props;

        // this.setState({baseok: select});
        let origin = [{id: "automatico", text: "Automatico"}, {id: "manual", text: "Manual"}];

        data = [];

        return (
            <div className="header-filter">
                <Accordion align='end' className="full-accordion">
                    <AccordionItem open="true" title="Filters (1)">

                        <div className="row">
                            <div className="col-3">
                                <TextInput
                                    helperText=""
                                    id="anme"
                                    name="name"
                                    invalidText="Invalid error message."
                                    labelText="Name"
                                    placeholder="Text name"
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div className="col-2"><Dropdown
                                useTitleInItem={false}
                                id="origin"
                                name="origin"
                                label="Report"
                                titleText="Origin"
                                placeholder="Select type"
                                invalid={false}
                                invalidText="Invalid Selection"
                                items={origin}
                                initialSelectedItem={origin[0]}
                                selectedItem={origin[0]}
                                itemToString={(item) => (item ? item.text : '')}
                                onChange={(evt) => {
                                    this.setState(prevState => ({
                                        form: {
                                            ...prevState.form,
                                            ['origin']: typeof (evt.selectedItem.id) ? evt.selectedItem.id : ""
                                        }
                                    }));
                                }}
                            /></div>
                            <div className="col-7">
                                <BasicDateTimePicker handledateFrom={(data) => this.onChangeDate(data)}
                                                     handledateTo={(data) => this.handledateTo(data)}
                                                     textHelper={"Select competency period"}/>
                            </div>
                        </div>
                        <div className="row flex-row-reverse" style={{paddingRight: "20px"}}>
                            <Button kind='primary'
                                    onClick={this.handleSubmit}
                            >Apply</Button>
                        </div>
                    </AccordionItem>
                </Accordion>
            </div>
        );
    }
}
